export default __webpack_public_path__ + "static/media/btc_dark.7d5b4e7e.svg";